var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassInput", {
    ref: "input",
    attrs: { value: _vm.value, placeholder: _vm.placeholder }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }